import { BearingFrequencyCalculator } from "./components/BearingFrequencyCalculator";

function BearingFrequencyCalculatorPage() {
  return <BearingFrequencyCalculator />;
}

export function createBearingFrequencyCalculatorPage() {
  return <BearingFrequencyCalculatorPage />;
}
